var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgProgressError = function SvgProgressError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 21 20",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_progress_error__clip0_2363_7166)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.5,
    fill: "#F17794",
    rx: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.438 15.104 10.5 11.167l-3.938 3.937-1.166-1.166L9.333 10 5.396 6.063l1.166-1.167L10.5 8.833l3.938-3.937 1.166 1.167L11.667 10l3.937 3.938z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_progress_error__clip0_2363_7166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 0.5,
    fill: "#fff",
    rx: 10
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProgressError);
export { ForwardRef as ReactComponent };